<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
  </div>
  <div class="row">
    <!-- SELECT TYPE DEAL -->
    <section class="col-12">
      <div class="card" [formGroup]="formGroupDetail">
        <!--TITLE-->
        <div class="card-title px-2 pt-2 mb-0">
          <h3>{{ "DETAIL_COMMISSION" | translate }}</h3>
        </div>
        <div class="card-body pb-0">
          <!--TYPE_SELECTION-->
          <div class="row">
            <div class="form-group col-xl-6 col-12">
              <label for="customer">{{ "CUSTOMER" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                id="customer"
                bindLabel="name"
                bindValue="id"
                formControlName="customer"
                [placeholder]="'PLACEHOLDER.SELECT_CUSTOMER' | translate"
                (change)="filterDeals()"
                [multiple]="false"
                [searchable]="true"
                [closeOnSelect]="true"
                [readonly]="(!!orderList && orderList[0].deal_id) || dealId"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                [items]="customersList"
              ></ng-select>
            </div>
            <div class="form-group col-xl-6 col-12">
              <label for="name">{{ "NAME" | translate }}<sup class="text-danger">*</sup></label>
              <input class="form-control" id="name" formControlName="name" [placeholder]="'PLACEHOLDER.INSERT_NAME' | translate" />
              <div class="invalid-feedback">{{ "ERRORS.FIELD_NAME" | translate }}</div>
            </div>
            <div
              class="form-group col-12 d-flex justify-content-end align-items-center"
              ngClass.sm="justify-content-between"
              *ngIf="!orderList[0].deal_id && !!formGroupDetail.value.customer && !!formGroupDetail.value.name && _authService.hasCapability('create_order')"
            >
              <button class="btn btn-outline-primary" (click)="modalOpen(detailOrder, null)">{{ "CREATE_COMMISSION" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--ADMINISTRATIVE DETAIL SECTION-->
    <section class="col-12" id="section2" *ngIf="!!orderList[0].deal_id">
      <div class="card" [ngClass]="activeTab === 'orders' ? 'active pb-0' : ''">
        <!--TITLE-->
        <div class="card-title px-2 mb-0" (click)="changeTab('orders')">
          <h3>{{ "ADMINISTRATIVE_DETAIL" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body p-0 mt-1' : 'd-none'" *ngIf="_utilService.isDesktop">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="60"
            [limit]="10"
            [footerHeight]="0"
            [rows]="orderList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.progressive_id ? row.progressive_id : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PRODUCTS' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="text-break-line-1" [ngbTooltip]="row.products_names ? row.products_names : null">{{ row.products_names ? row.products_names : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FROM' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TO' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CAPACITY' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.capacity }} €</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RESIDUE' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.residue }} €</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <button class="btn" [ngbTooltip]="'EDIT' | translate" (click)="modalOpen(detailOrder, row)"><i data-feather="edit-2" size="19"></i></button>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
        <div [ngClass]="activeTab === 'orders' ? 'card-body pb-0' : 'd-none'" *ngIf="_utilService.isTablet || _utilService.isMobile">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="270"
            [limit]="10"
            [footerHeight]="50"
            [rows]="orderList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'ROUND' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row">
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "ROUND" | translate }}: </span>
                    <span>{{ row.progressive_id ? row.progressive_id : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "PRODUCTS" | translate }}: </span>
                    <span class="text-break-line-1" [ngbTooltip]="row.products_names ? row.products_names : null">{{ row.products_names ? row.products_names : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "FROM" | translate }}: </span>
                    <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "TO" | translate }}: </span>
                    <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "CAPACITY" | translate }}: </span>
                    <span>{{ row.capacity }} €</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "RESIDUE" | translate }}: </span>
                    <span>{{ row.residue }} €</span>
                  </div>
                  <div class="col-12 d-flex justify-content-end">
                    <button class="btn" [ngbTooltip]="'EDIT' | translate" (click)="modalOpen(detailOrder, row)">
                      <i data-feather="edit-2" size="19"></i>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
    <div class="col-12 text-right" *ngIf="!!orderList[0].deal_id">
      <button class="btn btn-primary" (click)="createCommission()">{{ "CREATE_COMMISSION" | translate }}</button>
    </div>
  </div>
</div>

<!-- Modal Detail Order -->
<ng-template #detailOrder let-modal>
  <form [formGroup]="formGroupOrder">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="!!orderList[0].deal_id ? modal.dismiss('Cross click') : goToDealsList()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "DETAIL_ROUND" | translate }}</h3>
      <div class="row">
        <div class="form-group col-xl-4 col-12">
          <div class="d-flex justify-content-between">
            <label [for]="'deal_id'">{{ "DEAL" | translate }}<sup class="text-danger">*</sup></label>
            <a class="font-small-3" target="_blank" [routerLink]="'/dashboard/deals/edit/' + selectedDeal.id" *ngIf="selectedDeal">{{ "VIEW_DEAL" | translate }}</a>
          </div>
          <ng-select
            id="deal_id"
            bindLabel="complete_name"
            bindValue="id"
            formControlName="deal_id"
            [readonly]="dealId"
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            (change)="selectDeal()"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            [items]="dealsFilteredList"
          ></ng-select>
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal">
          <label [for]="'order_number'">{{ "ORDER_NUMBER" | translate }}</label>
          <input formControlName="order_number" name="order_number" type="text" [id]="'order_number'" maxlength="100" class="form-control" />
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal">
          <label [for]="'order_date'">{{ "ORDER_DATE" | translate }}</label>
          <app-datepickr id="order_date" [defaultDate]="formGroupOrder.value.order_date" (onSelect)="takeDate($event, 'order_date')" [minDateToday]="setMinDateToday"></app-datepickr>
        </div>
        <div class="form-group col-12" *ngIf="selectedDeal">
          <label [for]="'order_description'">{{ "ORDER_DESCRIPTION" | translate }}</label>
          <input formControlName="order_description" name="order_description" type="text" [id]="'description'" class="form-control {{ fieldHasErrors('order_description') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.order_description?.errors?.maxlength">
            {{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}
          </div>
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal">
          <label for="type">{{ "TYPE_ORDER" | translate }}</label>
          <ng-select id="type" [ngModelOptions]="{ standalone: true }" (change)="changeTypeDeal()" [(ngModel)]="typeDeal" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
            <ng-option value="Product">{{ "PRODUCT" | translate }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal">
          <label [for]="'from'">{{ "FROM" | translate }}</label>
          <app-datepickr id="from" [defaultDate]="formGroupOrder.value.from" (onSelect)="takeDate($event, 'from'); calculateTrancheNumberAndFrequency()" [minDateToday]="setMinDateToday"></app-datepickr>
        </div>
        <div class="form-group col-xl-4 col-12" *ngIf="selectedDeal">
          <label [for]="'to'">{{ "TO" | translate }}</label>
          <app-datepickr id="to" [defaultDate]="formGroupOrder.value.to" (onSelect)="takeDate($event, 'to'); calculateTrancheNumberAndFrequency()" [minDateToday]="setMinDateToday"></app-datepickr>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <label for="product">{{ "PRODUCTS" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            id="product"
            bindLabel="name"
            bindValue="id"
            formControlName="products_ids"
            [hideSelected]="true"
            [placeholder]="'PLACEHOLDER.SELECT_ONE_OR_MORE_PRODUCT' | translate"
            [multiple]="true"
            [searchable]="true"
            [closeOnSelect]="true"
            class="{{ fieldHasErrors('products_ids') ? 'is-invalid' : '' }}"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            [items]="productsList"
            (change)="manageRow()"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.PRODUCTS_REQUIRED" | translate }}</div>
        </div>

        <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Product'">
          <label [for]="'tranche_number'">{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
          <input formControlName="tranche_number" [readonly]="true" name="tranche_number" type="number" [id]="'tranche_number'" class="form-control {{ fieldHasErrors('tranche_number') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_NUMBER" | translate }}</div>
        </div>
        <div class="form-group col-xl-3 col-12" *ngIf="typeDeal && typeDeal === 'Product'">
          <label [for]="'tranche_import'">{{ "TRANCHE_IMPORT" | translate }}<sup class="text-danger">*</sup></label>
          <input
            (change)="formatMoneyValue('tranche_import')"
            formControlName="tranche_import"
            name="tranche_import"
            type="text"
            [id]="'tranche_import'"
            class="form-control {{ fieldHasErrors('tranche_import') ? 'is-invalid' : '' }}"
          />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_TRANCHE_IMPORT" | translate }}</div>
        </div>

        <div class="form-group col-xl-3 col-12" *ngIf="selectedDeal">
          <div class="d-flex flex-sm-column flex-md-row justify-content-md-between align-items-md-center">
            <label [for]="'capacity'">{{ "CAPACITY" | translate }}<sup class="text-danger">*</sup></label>
            <label
              class="text-danger font-small-2"
              [for]="'capacity'"
              *ngIf="selectedDeal?.deal_document?.table[0]?.total_discounted_deal && selectedDeal?.deal_document?.table[0]?.total_discounted_deal !== selectedDeal?.deal_document?.table[0]?.total_deal"
            >
              {{ "DISCOUNT_PROPOSED_TO_CUSTOMER" | translate }}: {{ selectedDeal?.deal_document?.table[0]?.total_discounted_deal }} € {{ "NOT_DISCOUNTED" | translate }}:
              {{ selectedDeal?.deal_document?.table[0]?.total_deal }} €
            </label>
          </div>
          <input (change)="formatMoneyValue('capacity')" formControlName="capacity" name="capacity" type="text" [id]="'capacity'" class="form-control {{ fieldHasErrors('capacity') ? 'is-invalid' : '' }}" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_CAPACITY" | translate }}</div>
        </div>
        <div class="col-12" *ngIf="typeDeal && typeDeal === 'Product'">
          <div class="row" *ngFor="let row of productsArray; let i = index">
            <div class="form-group col-xl-3 col-12">
              <label [for]="'product_id' + i">{{ "PRODUCT" | translate }}<sup class="text-danger">*</sup></label>
              <ng-select
                [id]="'product_id' + i"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="row.product_id"
                [readonly]="true"
                [multiple]="false"
                [searchable]="true"
                [closeOnSelect]="true"
                [ngModelOptions]="{ standalone: true }"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                [items]="productsList"
              ></ng-select>
            </div>
            <div class="form-group col-xl-2 col-12">
              <label [for]="'quantity_' + i">{{ "QUANTITY" | translate }}<sup class="text-danger">*</sup></label>
              <input [(ngModel)]="row.quantity" name="quantity" type="text" [id]="'quantity_' + i" class="form-control" [ngModelOptions]="{ standalone: true }" />
            </div>
            <div class="form-group col-xl-2 col-12">
              <label [for]="'price_' + i">{{ "PRICE" | translate }}<sup class="text-danger">*</sup></label>

              <input (change)="formatPrice(i)" [(ngModel)]="row.price" name="price" type="text" [id]="'price_' + i" class="form-control" [ngModelOptions]="{ standalone: true }" />
            </div>
            <div class="form-group col-xl-2 col-12">
              <label [for]="'tranche_number_' + i">{{ "TRANCHE_NUMBER" | translate }}<sup class="text-danger">*</sup></label>
              <input formControlName="tranche_number" name="tranche_number_" type="text" [id]="'tranche_number_' + i" class="form-control" [readonly]="true" [ngModelOptions]="{ standalone: true }" />
            </div>
            <div class="form-group col-xl-3 col-12">
              <label [for]="'tranche_single_import_' + i">{{ "TRANCHE_IMPORT_PRODUCT" | translate }}<sup class="text-danger">*</sup></label>
              <input [(ngModel)]="row.tranche_single_import" [readonly]="true" name="tranche_single_import" type="text" [id]="'tranche_single_import_' + i" class="form-control" [ngModelOptions]="{ standalone: true }" />
            </div>
          </div>
        </div>

        <div class="form-group col-12" *ngIf="selectedDeal">
          <label [for]="'description'">{{ "ROUND_DESCRIPTION" | translate }}</label>
          <textarea formControlName="description" name="description" type="text" [id]="'description'" class="form-control {{ fieldHasErrors('description') ? 'is-invalid' : '' }}"></textarea>
          <div class="invalid-feedback" *ngIf="formGroupOrder.controls?.description?.errors?.maxlength">
            {{ "ERRORS.DESCRIPTION_MAX_LENGTH" | translate }}
          </div>
        </div>
        <div class="form-group col-xl-6" *ngIf="selectedDeal">
          <label [for]="'billing_frequency'">{{ "BILLING_FREQUENCY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            (change)="calculateTrancheNumberAndFrequency()"
            class="{{ fieldHasErrors('billing_frequency') ? 'is-invalid' : '' }}"
            id="billing_frequency"
            bindLabel="name"
            bindValue="id"
            formControlName="billing_frequency"
            [items]="billingFrequencyList"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_BILLING_FREQUENCY" | translate }}</div>
        </div>
        <div class="form-group col-xl-6 col-12" *ngIf="selectedDeal">
          <label [for]="'payment_terms'">{{ "PAYAMENT_TERMS" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            class="{{ fieldHasErrors('payment_terms') ? 'is-invalid' : '' }}"
            id="payment_terms"
            bindLabel="name"
            bindValue="id"
            formControlName="payment_terms"
            [items]="paymentsTermsList"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_TERMS" | translate }}</div>
        </div>
        <div class="form-group col-xl-6" *ngIf="selectedDeal">
          <label [for]="'invoice_type'">{{ "INVOICE_TYPE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            class="{{ fieldHasErrors('invoice_type') ? 'is-invalid' : '' }}"
            id="invoice_type"
            bindLabel="name"
            bindValue="id"
            formControlName="invoice_type"
            [items]="invoiceTypeList"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_INVOICE_TYPE" | translate }}</div>
        </div>
        <div class="form-group col-xl-6" *ngIf="selectedDeal">
          <label [for]="'payment_measure_unit'">{{ "PAYMENT_MEASURE_UNIT" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [multiple]="false"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            class="{{ fieldHasErrors('payment_measure_unit') ? 'is-invalid' : '' }}"
            id="payment_measure_unit"
            bindLabel="name"
            bindValue="id"
            formControlName="payment_measure_unit"
            [items]="paymentMeasureUnitList"
            [readonly]="typeDeal === 'Product'"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PAYMENT_MEASURE_UNIT" | translate }}</div>
        </div>
        <div class="form-group ml-1 custom-control custom-control-primary custom-switch" *ngIf="selectedDeal" [ngClass.sm]="'col-12 ml-2 mb-1'">
          <small class="mr-025">{{ "CUSTOMER_APPROVAL" | translate }}</small>
          <input type="checkbox" class="custom-control-input" id="customerApproval" formControlName="client_approval" />
          <label class="custom-control-label" for="customerApproval"> </label>
        </div>
      </div>
      <!--File Section-->
      <div class="row mt-1" *ngIf="selectedDeal">
        <div class="col-xl-6 col-12" ngClass.xl="border-right" ngClass.md="mb-1" ngClass.sm="mb-1">
          <h3>{{ "DOCUMENT_ORDER" | translate }}</h3>
          <div class="row">
            <div class="col-xl-6 col-12">
              <div id="file-uploader" class="custom-file mt-1">
                <input class="custom-file-input" type="file" lang="it" id="file" [multiple]="false" (change)="addFileToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="files_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetFilesList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-11 mt-3 border-top pt-1" *ngIf="files_list_obj.length > 0">
              <div *ngFor="let file of files_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeFileFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ files_list_obj.length }}</div>
            </div>
            <div class="col-12 mt-1" *ngIf="files_list_obj.length < 1">
              <p>{{ "NO_ORDER_FILE_SELECTED" | translate }}</p>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <h3>{{ "ATTACHMENTS_ORDER" | translate }}</h3>
          <div class="row">
            <div class="col-xl-6 col-12">
              <div id="attachment-uploader" class="custom-file mt-1">
                <input class="custom-file-input" type="file" lang="it" id="attachment" [multiple]="true" (change)="addAttachmentToList($any($event).target.files)" accept="application/pdf" />
                <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mt-1">
              <div class="d-flex align-items-center justify-content-between">
                <div *ngIf="attachments_list_obj.length > 0">
                  <button class="btn btn-outline-danger" (click)="resetAttachmentsList()">{{ "RESET" | translate }}</button>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 border-top pt-1" *ngIf="attachments_list_obj.length > 0">
              <div *ngFor="let file of attachments_list_obj; let i = index" class="d-flex border-bottom mb-1 pb-1">
                <div class="flex-basis-60 d-flex align-items-center">
                  <div class="mr-05 cursor-pointer" (click)="removeAttachmentFromList(i)" *ngIf="file.status === 0">
                    <i [data-feather]="'x'" class="text-danger" size="18"></i>
                  </div>
                  <div class="mt-025">{{ file.name }}</div>
                </div>
                <div class="flex-basis-20 text-right">{{ file.size }}</div>
              </div>
              <div>{{ "TOTAL" | translate }}: {{ attachments_list_obj.length }}</div>
            </div>
            <div class="col-12 mt-1" *ngIf="attachments_list_obj.length < 1">
              <p>{{ "NO__ORDER_ATTACHMENTS_SELECTED" | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center" *ngIf="selectedDeal">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')" rippleEffect *ngIf="!!orderList[0].deal_id">
        {{ "BACK" | translate }}
      </button>
      <button type="submit" class="btn btn-primary w-150" rippleEffect (click)="createOrder()">
        {{ "SAVE" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Detail Order -->
